import { Constructor } from 'interfaces/constructor';
import { WCCContentBlock } from '../blocks/block/block';
import { WCCContentBlockType } from '../blocks/block/block.interfaces';

export function MakeEmbedWCCContentBlock(inline = false) {
    return function<TBase extends Constructor<any[], WCCContentBlock>>(Base: TBase) {
        abstract class ExtendedWCCContentBlock extends Base {
            protected override getLength() {
                return 1;
            }

            protected override getType(): WCCContentBlockType {
                return inline ? 'inline-embed' : 'embed';
            }

            protected override getWrapper() {
                if (!inline)
                    return ko.utils.parseHtmlFragment(`<div class="content-block--embed"></div>`)[0];
            }
        }

        return ExtendedWCCContentBlock;
    }
}